import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

export default function ContactModal({ isContactModal, closeModal }) {

  if (isContactModal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return (
    <>
      {isContactModal && (
        <div className={`fixed top-0 left-0 w-full h-full flex items-center justify-center text-center glassmorphism fadeIn`} onClick={closeModal}>
          <div className="p-8 mx-auto max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <p className='text-neutral-50 text-2xl font-semibold mb-5 uppercase  panoragraf-light'>Contattaci</p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-10">
              <div className="flex flex-col space-y-4">
                <p className="text-white font-bold text-lg">Verona</p>
                <a href="https://wa.me/+393202474886" id="whatsapp_verona"
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                  <FontAwesomeIcon icon={faWhatsapp} className="mr-2 " /> WhatsApp
                </a>
                <a href="tel:+390459856026" id="call_verona"
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                  <FontAwesomeIcon icon={faPhoneAlt} className="mr-2 " /> Call
                </a>
              </div>
              <div className="flex flex-col space-y-4">
                <p className="text-white font-bold text-lg">Sona</p>
                <a href="https://wa.me/+393532137757" id="whatsapp_sona"
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                  <FontAwesomeIcon icon={faWhatsapp} className="mr-2 " /> WhatsApp
                </a>
                <a href="tel:+393532137757" id="call_sona"
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                  <FontAwesomeIcon icon={faPhoneAlt} className="mr-2 " /> Call
                </a>
              </div>
              
              {/* <a href="https://wa.me/+393202474886"
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                <FontAwesomeIcon icon={faWhatsapp} className="mr-2 " /> WhatsApp
              </a>
              <a href="mailto:info@mcarefisio.it"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                <FontAwesomeIcon icon={faEnvelope} className="mr-2 " /> Email
              </a>
              <a href="tel:+390459856026"
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                <FontAwesomeIcon icon={faPhoneAlt} className="mr-2 " /> Call
              </a> */}
            </div>
            <div className="flex justify-center mt-10">
                <a href="mailto:info@mcarefisio.it"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 w-80 md:w-25  panoragraf-light">
                <FontAwesomeIcon icon={faEnvelope} className="mr-2 " /> Email
              </a>
            </div>
          </div>
        </div>
        
      )}
    </>
  )
}